import {Component, NgZone, ViewChild} from "@angular/core";
import {AlertOptions, IonContent, NavController, Platform} from "@ionic/angular";
import {ActivatedRoute, NavigationEnd, Router, RoutesRecognized} from "@angular/router";

import {Capacitor} from "@capacitor/core";
import {App, URLOpenListenerEvent} from "@capacitor/app";
import {PushNotifications} from '@capacitor/push-notifications';
import {KeyboardResize} from "@capacitor/keyboard";
import {Style} from "@capacitor/status-bar";

import {environment} from "@environments/environment";

// import {initializeApp} from 'firebase/app';
// import {getMessaging, getToken} from "firebase/messaging";

import {interval, Subject} from "rxjs";
import {filter, share, skip, startWith, takeUntil} from "rxjs/operators";

import {ApiService} from "@services/api.service";
import {HttpService} from "@services/http/http.service";
import {UiHelperService} from "@services/ui-helper/ui-helper.service";
import {StorageService} from "@services/storage/storage.service";
import {VideoCallService} from "@services/video-call/video-call.service";
import {EventService} from "@services/events/event.service";
import {AuthService} from "@services/auth/auth.service";
import {NavParamsService} from "@services/navParams/nav-params.service";
import {UserService} from "@services/user/user.service";
import {MenuService} from "@services/menu/menu.service";
import {SearchParamsService} from "@services/searchParams/search-params.service";

import {appRoutingEnum} from "@enums/appRoutingEnum";

import {StandardResponse} from "@interfaces/general.types";
import {SwPush} from "@angular/service-worker";
import {BingoData} from "@pages/bingo/bingo.page";
import {LoginPage} from "@pages/login/login.page";
import { StatusBar } from '@capacitor/status-bar';
import { Keyboard } from '@capacitor/keyboard';
import {StatusEnum} from "@enums/statusEnum";
import {HttpHeaders} from "@angular/common/http";

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
  standalone: false,
})
export class AppComponent {
  //@ViewChild('ion-content', {static: false}) content!: IonContent;
  readonly VAPID_PUBLIC_KEY = "BJiLuum4PU6_DW9GgTtOCayjjbtt7TGjJkivSiYHAJNGLNV0nXlxIStivSiCHMNw8jvwwasUUrgss1zhYVS9vVo";
  public banner: any;
  public status: any = '';
  public texts: any = {};
  public new_message: any = '';
  public message: any = {};
  public avatar: any = '';
  public is2D: any;
  public lastCallId: any = null;
  public envShowBanner = environment.displayBanner;
  private _destroy$: Subject<boolean> = new Subject<boolean>();
  private _intervalDestroy$: Subject<boolean> = new Subject<boolean>();
  public linkReload: any;
  public form: any;
  public data: any;
  public html: any;
  public isSearch: boolean = true;
  public displayErrors: any = false;
  public errors: any = '';
  public openLogin: any = false;
  public token:any;



  constructor(
    public platform: Platform,
    public menuService: MenuService,
    public api: ApiService,
    public http: HttpService,
    public events: EventService,
    public navCtrl: NavController,
    private navParams: NavParamsService,
    private searchParams: SearchParamsService,
    private router: Router,
    public uiHelper: UiHelperService,
    public storage: StorageService,
    public videoCall: VideoCallService,
    public auth: AuthService,
    public userProfile: UserService,
    private zone: NgZone,
    private swPush: SwPush,
    private activatedRoute: ActivatedRoute,

  ) {
    console.log("final version 1");
    this._destroy$.next(false);
    this._intervalDestroy$.next(false);
    this.closeMsg();
    this.initializeApp();
    this.initPushNotification();

    if (this.auth.getIsLogin()) {
      this.getBingo();
    }
    this.menuService.initializeMenus();
    this.getAppVersion();


    App.addListener('appStateChange', async (appState) => {
      if (appState.isActive) {
        await this.zone.run(async () => {
          if (Capacitor.isPluginAvailable('PushNotifications')) {
            PushNotifications.removeAllDeliveredNotifications().then();
          }
          const lastPage = (await this.storage.getItem('lastPage')) as string;
          const password = (await this.storage.getItem('password')) as string;
          const username = (await this.storage.getItem('username')) as string;

          if (username && password) {
            this.auth.formSubmit(username, password).subscribe(instructions => {
              if (instructions.error) {
              }
              if (lastPage) {
                this.router.navigate([lastPage]).then();
              } else {
                if (instructions.state) {
                  this.navParams.set(instructions.state);
                }
                if (instructions.destination) {
                  this.router.navigate([instructions.destination]).then();
                }
              }
            });
          }
        });
      }
    });

    App.addListener('appRestoredResult', data => {
      this.zone.run(() => {
      });
    });

    App.addListener('appUrlOpen', (event: URLOpenListenerEvent) => {
      this.zone.run(() => {
      });
    });
    this.linkReload = appRoutingEnum.RELOAD;
    this.getData();
  }

  getData(){
    this.api.http.get(this.api.http.url + '/home_page').subscribe((data:any) => {
      this.data = data;
      // console.log(data)
      if(typeof this.html == 'undefined') {
        this.html = {};
      }
      this.data.forEach( (value: any) => {
        if(value.type == 'top_header'){
          this.html.top_header = value;
        }
        // console.log(value);
        if(value.type == 'form'){
          this.form = value;
        }
        if(value.type == 'slider'){
          this.html.slider = value;
        }
        if(value.type == 'search'){
          this.html.search = {};
          value.form.forEach((field: any) => {
            if(field.type == 'text' || field.type == 'select'){
              this.html.search[field.name] = {'value':''};
            }
          });
          this.isSearch = Object.keys(this.html.search).length > 0;
        }
      });
    });
  }

  async openLoginPopup(focus = 0){
    console.log(this.openLogin);
    if(!this.openLogin) {
      this.openLogin = true;
      this.form.focus = focus;
      const loginModal:any = await this.api.modalCtrl.create({
        component: LoginPage,
        componentProps: {
          'data': this.form
        }
      });
      await loginModal.present();

      loginModal.onDidDismiss().then((modalDismissEvent:any) => {
        const data = modalDismissEvent.data;
        if (data) {
          this.form.username.value = data.username;
          this.form.password.value = data.password;
          // if (typeof data.send != 'undefined' && data.send == 1) {
          //this.formSubmit();
          // }
          if(typeof data.app != 'undefined') {
            if (data.app == 'login') {
              if (this.api.pageName != appRoutingEnum.HOME) {
                this.router.navigate([appRoutingEnum.HOME]);
              }
            } else {
              if (this.api.pageName != appRoutingEnum.CHANGE_PHOTO && this.api.pageName != appRoutingEnum.ACTIVATION) {
                this.router.navigate([appRoutingEnum.ACTIVATION]);
              }
            }
          }
          if (typeof data.recovery != 'undefined' && data.recovery == 1) {
            this.router.navigate([appRoutingEnum.PASSWORD_RECOVERY]);
          }
          if (typeof data.register != 'undefined' && data.register == 1) {
            this.router.navigate([appRoutingEnum.REGISTER]);
          }
        }
        this.openLogin = false;
      });
    }
  }

  /**
   * Gets ap version from the server and compares it to the one installed. Offers update if possible,
   * forces update if necessary.
   * @return StandardResponse
   * @type {()=>StandardResponse}
   */
  getAppVersion(): StandardResponse {
    let response: StandardResponse = {success: false, message: 'Nothing done yet'};
    this.http.get(this.http.url + '/app/version').subscribe((data: any) => {
      response = {success: true, message: 'data fetched from server', data, result: data};
      const buttons = [{
        text: data.update,
        handler: () => {
          window.open(data.android.url, '_system');
          if (data.android.update == '1') {
            this.getAppVersion();
          }
        }
      }];
      if (data.android.update != '1') buttons.push({
        text: data.cancel, handler: () => {
          if (data.android.update == '1') {
            this.getAppVersion();
          }
        }
      });
      if (parseInt(data.android.version) > parseInt(this.api.appVersion)) {
        this.uiHelper.presentAlert({
          header: data.title,
          message: data.message,
          cssClass: 'new-version',
          buttons
        })
      }
    }, (err: any) => {
      this.uiHelper.hideLoader();
      response = {success: false, message: 'An error has occurred, see more in the data field', data: err};
    });
    return response;
  }

  closeMsg() {
    this.new_message = '';
  }

  getStatistics() {
    if (this.auth.getIsLogin()) {
      this.http.get(this.http.url + '/user/statistics/').subscribe((data: any) => {
        if(typeof data.status != 'undefined' && data.status == 'renew'){
          this.http.userLogin();
        }
        let statistics = data.statistics;
        if (typeof statistics != 'undefined') {
          console.log(this.api.pageName);
          console.log(data.isPay);
          console.log(this.auth.getIsPaying());
          if (this.auth.getStatus() != data.status || data.isPay != this.auth.getIsPaying()) {
            //(data.isPay == 1 && this.api.pageName == appRoutingEnum.SUBSCRIPTION) || (data.isPay == 0 && this.api.pageName != appRoutingEnum.SUBSCRIPTION)
            this.auth.setStatus(data.status);
            this.is2D = data.is2D;
            this.auth.setIsPaying(data.isPay);
            this.auth.setIsAccountLessThan2DaysOld(data.is2D);
            if (data.status == StatusEnum.NOT_ACTIVATED) {
              this.router.navigate([appRoutingEnum.ACTIVATION]).then();
            } else if (data.status == StatusEnum.NO_IMG ) {
              this.router.navigate([appRoutingEnum.CHANGE_PHOTO]).then();
            } else if (data.isPay == 0 && data.status == 'login' && this.api.pageName != appRoutingEnum.SUBSCRIPTION) {
              this.router.navigate([appRoutingEnum.SUBSCRIPTION]).then();
            } else if (data.isPay == 1 && data.status == 'login' && this.api.pageName == appRoutingEnum.SUBSCRIPTION) {
              this.router.navigate([appRoutingEnum.HOME]).then();
            }
          }
          this.menuService.updateStatistics(statistics);

        }
      }, err => {
        this.uiHelper.hideLoader();
      });
    }
  }

  clearLocalStorage() {
    // Removing data storage
    this.storage.remove('user_id').then();
    this.storage.remove('user_photo').then();

    this.auth.logout();
  }

  initializeApp() {
    this.platform.ready().then(() => {
      StatusBar.setOverlaysWebView({ overlay: false });
      Keyboard.setScroll({ isDisabled: false }); // Enable scrolling
      this.uiHelper.statusBar?.setStyle({style: Style.Light}).then();
      this.uiHelper.keyboard?.setAccessoryBarVisible({isVisible: false}).then();
      this.uiHelper.keyboard?.setResizeMode({mode: KeyboardResize.Ionic}).then();
    });

  }

  initPushNotification() {
    //console.log('push1');
    if (Capacitor.isPluginAvailable('PushNotifications')) {
      PushNotifications.requestPermissions().then(() => PushNotifications.register().then());
      //console.log('push2');
      if (Capacitor.getPlatform() == 'android') {
        //console.log('push3');
        PushNotifications.createChannel({
          id: 'video',
          name: 'richdate incoming video',
          description: 'RichDate video call notification',
          sound: 'landline_phone_ring',
          importance: 5,
          visibility: 1,
          lights: true,
        }).then();
        PushNotifications.createChannel({
          id: 'message',
          name: 'RichDate push notification',
          description: 'RichDate push notification',
          sound: 'ding_dong',
          importance: 5,
          visibility: 1,
          vibration: true,
        }).then();
      }

      PushNotifications.addListener('registration', (token) => {
        this.storage.setItem('deviceToken', token.value).then();

        this.api.sendPhoneId(token.value);
      });

      PushNotifications.addListener('registrationError', (data) => {
        console.log(data);
      });

      PushNotifications.addListener('pushNotificationReceived', (data) => {
        this.storage.getItem('user_id').then((val) => {
          if (val) {
            if (data.data.foreground == false) {
              if (typeof data.data.video != 'undefined' && data.data.video == '1') {
                this.videoCall.openVideoChat({
                  id: data.data.userId,
                  chatId: 0,
                  alert: false,
                  username: data.data.userNick,
                });
              } else {
                this.openPushMessage(data);
              }
            } else {
              if (((typeof data.data.video != 'undefined' && data.data.video != '1') || typeof data.data.video == 'undefined') && this.api.pageName != appRoutingEnum.DIALOG && data.data.onlyInBackgroundMode == '0') {
                this.uiHelper.presentAlert({
                  header: data.data.titleMess,
                  message: data.body,
                  buttons: [
                    {
                      text: data.data.buttons[0], role: 'cancel', handler: () => {
                      }
                    },
                    {text: data.data.buttons[1], handler: () => this.openPushMessage(data)}]
                });
              }
            }
          } else this.router.navigate([appRoutingEnum.MAIN]).then();
        });
      });
    } else {
      this.swPush.requestSubscription({
        serverPublicKey: this.VAPID_PUBLIC_KEY
      })
        .then(sub => {
          console.log('Push Subscription:', sub);
          // Here, you need to send `sub` to your server
          this.http.post(this.http.url + '/browser-sub',{ subscription: sub }).subscribe();
        })
        .catch(err => console.error("Could not subscribe to notifications", err));

      this.swPush.messages.subscribe(message => {
        console.log('Received push message', message);
      });

      this.swPush.notificationClicks.subscribe((click: any) => {
        console.log('Notification click', click);
        this.router.navigate([click.notification?.data?.url]).then();
      });
    }
  }

  // private initializeWebPush() {
  //   const firebaseConfig:any = {
  //     apiKey: "AIzaSyCcZDm1LRBcLKTbmu90fAJvVcED9-jDcT0",
  //     authDomain: "new-richdate.firebaseapp.com",
  //     projectId: "new-richdate",
  //     storageBucket: "new-richdate.appspot.com",
  //     messagingSenderId: "696547057948",
  //     appId: "1:696547057948:web:124e5c2d1f38bd22ad9ad9",
  //     measurementId: "G-RSJZM2NQR1"
  //   };
  //   const app:any = initializeApp(firebaseConfig);
  //   const messaging:any = getMessaging(app);
  //   getToken(messaging, {vapidKey: this.VAPID_PUBLIC_KEY}).then(currentToken => {
  //     this.storage.setItem('deviceToken', currentToken).then();
  //     this.api.sendPhoneId(currentToken);
  //   }).catch((err:any) => console.log(err));
  // }

  openPushMessage(dataOpen:any) {
    if (typeof dataOpen.additionalData.urlRedirect == 'undefined') {
      if (typeof dataOpen.additionalData.userId == 'undefined') {
        this.router.navigate([appRoutingEnum.INBOX]).then();
      } else {
        this.router.navigate([appRoutingEnum.DIALOG + '/' + dataOpen.additionalData.userId]).then();
      }
    } else {
      window.open(dataOpen.additionalData.urlRedirect, '_system');
    }
  }

  getBanner() {
    this.http.get(this.http.url + '/user/banner_new').subscribe((data: any) => {
      //console.log(data);
      const notBannerPages = [appRoutingEnum.ACTIVATION,appRoutingEnum.ADMIN_MESSAGES,appRoutingEnum.ARENA,appRoutingEnum.BINGO,appRoutingEnum.DIALOG,appRoutingEnum.FULL_SCREEN_PROFILE,appRoutingEnum.LOGIN,appRoutingEnum.REGISTER,appRoutingEnum.SUBSCRIPTION];
      console.log(this.api.pageName);
      console.log(!notBannerPages.includes(this.api.pageName));
      if(!notBannerPages.includes(this.api.pageName)) {
        if (data.banner) {
          //banner settings
          console.log(this.auth.getIsLogin() && data.banner.before_login == '0');
          console.log(!this.auth.getIsLogin() && data.banner.after_login == '0');
          if((this.auth.getIsLogin() && data.banner.before_login == '0') || (!this.auth.getIsLogin() && data.banner.after_login == '0') || (data.banner.before_login == '1' && data.banner.after_login == '1')) {
            this.banner = data.banner;
            this.uiHelper.isBanner = (this.banner.href != '');
            console.log(this.uiHelper.isBanner);
          }else{
            this.banner = false;
            this.uiHelper.isBanner = false;
          }
        }else{
          this.banner = false;
          this.uiHelper.isBanner = false;
        }
      }else{
        this.banner = false;
        this.uiHelper.isBanner = false;
      }
    });
  }

  goTo() {
    if(this.banner.href.includes("http")) {
      window.open(this.banner.href, '_blank');
    }else {
      //inside link
      this.router.navigate([this.banner.href]).then();
    }
    return false;
  }

  homePage() {
    this.searchParams.resetParams();
    this.storage.getItem('user_id').then((val) => {
      const dest = val ? appRoutingEnum.HOME : appRoutingEnum.MAIN;
      this.router.navigate([dest]);
    });
  }

  getBingo() {
    this.http.get(this.http.url + '/user/bingo').subscribe((data: any) => {
      //this.storage.setItem('status', this.status);
      if(typeof data.status != 'undefined' && data.status == 'renew'){
        //console.log('123');
        this.http.userLogin();
      }
      this.texts = data.texts;
      if(typeof data.texts != 'undefined') {
        this.avatar = data.texts.avatar;
      }
      this.api.myPhotos = data.photos;
      // if (this.auth.getStatus() != data.logged) {
      //   this.auth.setStatus(data.logged);
      //   if (data.logged == StatusEnum.NOT_ACTIVATED) {
      //     this.router.navigate([appRoutingEnum.ACTIVATION]).then();
      //   } else if (data.logged == StatusEnum.NO_IMG ) {
      //     this.router.navigate([appRoutingEnum.CHANGE_PHOTO]).then();
      //   } else if (!this.auth.getIsPaying() && data.logged == 'login') {
      //     this.router.navigate([appRoutingEnum.SUBSCRIPTION]).then();
      //   } else {
      //     this.router.navigate([appRoutingEnum.HOME]).then();
      //   }
      // }
      if (data.user && data.logged != 'notActivated' && this.api.pageName != 'dialog' && this.api.pageName != 'bingo') {
        let params = JSON.stringify({
          bingo: data.user
        });
        this.navParams.set({data});
        this.router.navigate([appRoutingEnum.BINGO]).then();
        this.http.post(this.http.url + '/user/bingo/splashed', params).subscribe(() => {
        });
      }
    }, err => {
      this.uiHelper.hideLoader();
    });
  }


  gotoDialogPage() {
    let user:any = {id: this.new_message.userId};
    this.closeMsg();
    this.router.navigate([appRoutingEnum.DIALOG + '/' + user.id]).then();
  }


  showAlert(title:any, subTitle:any) {
    this.uiHelper.presentAlert({
      header: title,
      subHeader: subTitle,
      buttons: [{
        text: 'אישור',
        handler: () => {
          window.open("https://play.google.com/store/apps/details?id=com.interdate.richdate", "_system");
        }
      }]
    });
  }

  ngOnInit() {
    //skipping first because when we open app we don't always want to go to login page
    this.auth.isLogin$.pipe(share(), takeUntil(this._destroy$)).pipe(skip(1)).subscribe(isLogin => {//.pipe(distinct(), shareReplay())
        if (!isLogin) {
          this.clearLocalStorage();
          this.router.navigate([appRoutingEnum.MAIN]).then();
        }
      }
    );
    //if (this.swPush.isEnabled) {

    //}
  }

  ngAfterViewInit() {

    let interval$ = interval(3000).pipe(
      takeUntil(this._intervalDestroy$),
      startWith(0),
      filter(() => {
        return (!(this.api.pageName == appRoutingEnum.MAIN) && !!this.userProfile.getUsername() && !!this.userProfile.getPassword())
      }),
      share());

    this.router.events.pipe(
      takeUntil(this._destroy$),
      filter(ev => {
        return ((ev instanceof NavigationEnd) || (ev instanceof RoutesRecognized))
      }),
      share())
      .subscribe((ev) => {
        if (ev instanceof NavigationEnd) {
          this.storage.setItem('lastPage', this.router.url).then();
          this._intervalDestroy$.next(true);

          interval$/*.pipe(filter((value, index) => index % 3 === 0))*/.subscribe(() => {
            this.getBanner();
            this.getBingo();
            this.getStatistics();
          });
          interval$.subscribe(() => {
            //this.videoCall.getCalls();
          })
        } else {
          this._intervalDestroy$.next(false);
        }
      });

  }

  ngOnDestroy() {
    this._destroy$.next(true);
    this._destroy$.unsubscribe();
    this._intervalDestroy$.next(true);
    this._intervalDestroy$.unsubscribe();
  }
}

export interface MenuItem {
  _id: string,
  icon: string,
  title: string,
  component: appRoutingEnum,
  count?: number
  list?: string,
  src_img?: string
}
